// fetchLivestreamTopGifts.js
'use strict';
import getMeData from '../selector/getMeData.js';

import fetch from '../resource/customFetch.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';
import objectifyArrayById from '../resource/objectifyArrayById.js';
import addGifts from '../action/addGifts.js';

import {
  MERGE_LIVE_STREAM_DATA,
  SET_LIVE_STREAM_DATA,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Fetch livestream top gifts
 * @kind action
 * @param {object} payload - action payload.
 * @param {string} payload.streamId - stream id.
 * @param {string} payload.sessionId - session id.
 * @return {Promise} Action promise.
 * @see https://www.notion.so/swaglive/livestream-top-gifts-310926e209a3803f8fdddc3a812be842?source=copy_link
 */
const fetchLivestreamTopGifts =
  ({ streamId, sessionId } = {}) =>
  async (dispatch, getState) => {
    const networkingSelectPath = ['fetch', streamId, 'topGifts', sessionId];

    if (!sessionId || !streamId) return dispatch({ type: '' });

    const fetchOptions = {
      method: 'GET',
      headers: {
        ...getHeaders(),
      },
    };

    const token = getMeData(getState(), 'token');
    if (token) {
      fetchOptions.headers.Authorization = `Bearer ${token}`;
    }

    const fetchUrl = getResourceUrl({
      endpoint: `/sessions/${sessionId}/top-gifts`,
    });

    dispatch({
      type: SET_NETWORKING_FETCHING,
      payload: { selectPath: networkingSelectPath },
    });
    try {
      let response = await fetch(fetchUrl.href, fetchOptions);

      if (!response.ok) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl,
        });
      }

      // {
      //   "gifts": [
      //     {
      //       "id": "livestream-rabbit-ears-nov2-69",
      //       "price": "69",
      //       "title": null,
      //       "count": 7,
      //       "ui_type": "apng"
      //     },
      //     {
      //       "id": "livestream-thong-nov2-699",
      //       "price": "699",
      //       "title": null,
      //       "count": 1
      //     }
      //   ],
      //   "commands": [
      //     {
      //       "id": "karaoke--2121038378",
      //       "price": "200",
      //       "title": "哈哈哈",
      //       "duration": 20,
      //       "count": 1
      //     }
      //   ],
      //   "toys": []
      // }
      const payload = (await response.json()) || {};
      const { gifts = [], commands = [], toys = [] } = payload;

      const items = Object.entries(payload)
        .map(([type, items]) => items.map(item => ({ ...item, type })))
        .flat()
        .sort((a, b) => b.count - a.count);

      dispatch({
        type: SET_LIVE_STREAM_DATA,
        payload: {
          selectPath: [streamId, 'session', sessionId, 'topGift'],
          data: objectifyArrayById({ array: items }),
        },
      });

      // Store gifts into gift.items (same as fetchGift)
      if (gifts.length > 0) {
        dispatch(addGifts({ gifts: objectifyArrayById({ array: gifts }) }));
      }

      // Store commands and toys into liveStream[streamId].karaoke (same as handleStreamOnline)
      const karaokeItems = [...commands, ...toys].map(item => ({
        id: item.id,
        product_id: item.id,
        title: item.title,
        duration: item.duration,
        points: item.price,
      }));
      if (karaokeItems.length > 0) {
        dispatch({
          type: MERGE_LIVE_STREAM_DATA,
          payload: {
            selectPath: [streamId, 'karaoke'],
            data: objectifyArrayById({
              array: karaokeItems,
              keyAsId: 'id',
            }),
          },
        });
      }
      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath: networkingSelectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath: networkingSelectPath, error },
      });
    }
  };

export default fetchLivestreamTopGifts;
